import api from 'configs/api';
import { IRequestListResponse } from 'interfaces/RequestListResponse';
import { IInspectorTechnicianOptions } from 'interfaces/InspectorTechnician';
import { IAllOmegaUsersOptions } from 'interfaces/AllOmegaUsers';
import { IRequestResponse } from 'interfaces/RequestResponse';
import {
  IGridGroupPermission,
  IGridGroupPermissionDataResponse,
  IUserNameFilterData,
} from 'interfaces/Grid';

const endpointUrl = 'msgraph-users';

export const postInspectorTechnicianFilterOptions = async params => {
  const url = `${endpointUrl}/technician-members`;
  const { data } = await api.post<
    IRequestListResponse<IInspectorTechnicianOptions>
  >(url, params);
  return data;
};

export const postAllOmegaUsers = async params => {
  const url = `${endpointUrl}/all-omega-users`;
  const { data } = await api.post<IRequestListResponse<IAllOmegaUsersOptions>>(
    url,
    params,
  );
  return data;
};

export const postGroupPermissionGrid = async (qs: string, params: unknown) => {
  const url = `${endpointUrl}/grid?${qs}`;
  const { data } = await api.post<
    IRequestResponse<IGridGroupPermissionDataResponse<IGridGroupPermission[]>>
  >(url, params);
  return data;
};

export const postUserNameFilter = async (qsparams, params) => {
  const url = `${endpointUrl}/filter/user?${qsparams}`;
  const { data } = await api.post<IRequestResponse<IUserNameFilterData>>(
    url,
    params,
  );
  return data;
};
